import React from 'react';
import styled from '@emotion/styled';
import {Grid, Segment} from 'semantic-ui-react';
import {EzButton} from '@ezcater/recipe';
import {withEnvironmentContext} from './Environment';

const Heading = styled.h1`
  font-size: 3em;
  color: #369;
`;

const MessageDiv = styled.div`
  font-size: 1.5em;
`;

const hardRefreshPage = () => {
  window.location.reload(true);
};

const GeneralError = ({staticContext, environmentVars: {ezRailsDomain}, errorMessage}) => {
  if (staticContext) {
    staticContext.status = 404; // eslint-disable-line no-param-reassign
  }

  return (
    <Grid centered>
      <Grid.Row>
        <Segment basic padded="very" textAlign="center" data-testid="errorComponent">
          <a href={ezRailsDomain}>
            <img alt="ezCater Logo" src="/static/images/logo-dark.png" />
          </a>
          <Heading>Oh crumbs!</Heading>
          <MessageDiv>
            {errorMessage || 'Looks like something went wrong.'}
            <br />
            <br />
            Sorry things aren&apos;t so ez right now.
            <br />
            If you need immediate assistance,
            <br />
            please call 1-800-488-1803.
            <br />
            <br />
            <EzButton legacy use="primary" onClick={hardRefreshPage}>
              Reload
            </EzButton>
            <br />
          </MessageDiv>
        </Segment>
      </Grid.Row>
    </Grid>
  );
};

export default withEnvironmentContext(GeneralError);
